// Optional playlist of real tracks. Leave it empty to use the generative engine.
// Only add files you have the rights to use (e.g. tracks under the Pixabay Content License).
// `src` is relative to the site root (where index.html is); files must be served from the same site.
export default [
  // { src: 'music/night-walk.mp3', title: 'Night Walk', artist: 'Someone', license: 'Pixabay Content License' },
];
